import { EQUIPMENT_LIST, LOGIN, ME } from '../config';
import apiClient from './apiClient';

export async function validateToken() {
  const token = localStorage.getItem('jwtToken');
  if (!token) return null;

  try {
    const response = await apiClient.get(ME);
    const userData = response.data || {};
    localStorage.setItem('data', JSON.stringify(userData));
    sessionStorage.setItem('data', JSON.stringify(userData));
    return userData;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      sessionStorage.clear()
      window.location.href = '/login';
    }
    return null;
  }
}



export async function loginUser({ email, password }) {
  const response = await apiClient.post(LOGIN, { email, password });
  return response.data; // expects { token: '...' }
}

export async function getEquipments() {
  const response = await apiClient.get(EQUIPMENT_LIST);
  return response.data; // expects { token: '...' }
}


 export function  logOutUser(){
    localStorage.removeItem('data');
    localStorage.removeItem('jwtToken');
    sessionStorage.removeItem('data');
    sessionStorage.removeItem('jwtToken');
    localStorage.removeItem('equipment');
    window.location.href ='/login'
  };
